import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { isMobile } from "../../utils";
import HomeComponent from "../../components/FeatureConfig/Home/Index";
import * as UserActions from "../../store/actions/User";

const FeatureConfig = (props) => {
  console.log("logging props --> ", props);
  const { setSideBarCollapsed } = props;
  React.useEffect(() => {
    setSideBarCollapsed(true);
  });

  return (
    <FeatureConfigViewContainer className="Feature-Config-View container">
      <HomeComponent getNamespaces={props.getNamespaces} />
    </FeatureConfigViewContainer>
  );
};

const FeatureConfigViewContainer = styled.div`
  & > div {
    flex-direction: ${isMobile() ? "column" : "row"};
    .actionBar {
      margin-top: ${isMobile() ? "10px" : "unset"};
      margin-left: ${isMobile() ? "unset" : "auto"};
    }
  }
`;

function mapStateToProps(state) {
  const { FeatureConfig } = state;
  return {
    namespaces: FeatureConfig.namespaces,
    keys: FeatureConfig.keys,
    prevPage: FeatureConfig.prevPage,
    nextPage: FeatureConfig.nextPage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setSideBarCollapsed: bindActionCreators(
      UserActions.setSideBarCollapsed,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FeatureConfig);
